export default __webpack_public_path__ + "static/media/TA-Img3.75336ee8.svg";